export default {
    methods: {
        formatInteger: function (number) {
            if (!number) {
                return "0"
            }
            var formatter = new Intl.NumberFormat();
            return formatter.format(number);
        },
        formatNumber: function(number, digits = 0) {
            if (number === null) {
                return this.$t("supplierDetail.contracts.novalue")
            }
            if (!number) {
                return "0"
            }
            var formatter = new Intl.NumberFormat(undefined, { maximumFractionDigits: digits, minimumFractionDigits: digits });
            return formatter.format(number);
        },
        formatPercentage: function(number, digits = 0) {
            if (!number) {
                number = 0
            }

            return this.formatNumber(number * 100, digits) + "\xa0%";
        }
    }
}